module.exports = __webpack_public_path__ + "static/media/selectedResume.476d1419.svg";